<div class="main-content">
  <div class="container-fluid">

    <loader *ngIf="loading"></loader>

    <div *ngIf="!loading" class="services-table-wrap">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Epes</th>
              <th>Your Status</th>
              <th>Effort</th>
              <th>Report</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of assignedDeepDives; let i = index;">
              <td>{{ row['name'] }}</td>
              <td>{{ row['description'] }}</td>
              <td>
                <div class="epes-chips">
                  <span *ngFor="let epe of getEpes(row['epes'])" class="epe-chip">
                    {{ getEpeString(epe) }}
                  </span>
                </div>
              </td>
              <td>
                <span class="status-chip" [ngClass]="'status-' + getSelfStatus(getEpes(row['epes'])).toLowerCase().replace(' ', '-')">
                  {{ getSelfStatus(getEpes(row['epes'])) }}
                </span>
              </td>
              <td>{{ row['effort'] }}</td>
              <td>
                <div class="report-cell">
                  <div *ngIf="getReport(row) === ''" class="report-upload">
                    <input type="file" id="fileInput" (change)="onFileSelected($event)" class="form-control form-control-sm">
                  </div>
                  <a *ngIf="getReport(row) !== ''" download [href]="downloadReport(row)" class="row-link">
                    <i class="fa fa-file-text-o"></i> {{ getReport(row) }}
                  </a>
                  <button *ngIf="getReport(row) === ''" class="btn btn-sm btn-primary" (click)="uploadReport(row)">
                    <i class="fa fa-upload"></i> Upload
                  </button>
                  <button *ngIf="getReport(row) !== ''" class="btn btn-sm btn-danger" (click)="deleteReport(row)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
              <td>
                <button class="btn btn-sm btn-action" data-toggle="modal" data-target="#myModal" (click)="loadModalData(row)">
                  <i class="fa fa-pencil"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>

<div *ngIf="!loading" class="modal fade" id="myModal" tabindex="-1" role="dialog" data-backdrop="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i style="color: #d9534f;" class="fa fa-times"></i>
                </button>
                <h4 *ngIf="getSelfStatus(getEpes(selectedDeepDive['epes'])) === 'PENDING'" class="modal-title">Do you want to approve this deep dive?</h4>
                <h4 *ngIf="getSelfStatus(getEpes(selectedDeepDive['epes'])) === 'NOT APPROVED'" class="modal-title">You previously rejected this deep dive. Do you want to approve it now?</h4>
                <h4 *ngIf="getSelfStatus(getEpes(selectedDeepDive['epes'])) === 'APPROVED'" class="modal-title">You previously approved this deep dive. Do you want to reject it now?</h4>
            </div>
            <div class="modal-body">
                <p *ngIf="getSelfStatus(getEpes(selectedDeepDive['epes'])) === 'PENDING' || getSelfStatus(getEpes(selectedDeepDive['epes'])) === 'NOT APPROVED'">
                    Do you want to approve the <b>{{ selectedDeepDive['name'] }}</b> deep dive?
                </p>
                <p *ngIf="getSelfStatus(getEpes(selectedDeepDive['epes'])) === 'APPROVED'">
                    Do you want to reject the <b>{{ selectedDeepDive['name'] }}</b> deep dive?
                </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                <button *ngIf="getSelfStatus(getEpes(selectedDeepDive['epes'])) === 'APPROVED' || getSelfStatus(getEpes(selectedDeepDive['epes'])) === 'PENDING'"
                        type="button" class="btn btn-danger" data-dismiss="modal" (click)="reject(selectedDeepDive)">
                  <i class="fa fa-times"></i> Reject
                </button>
                <button *ngIf="getSelfStatus(getEpes(selectedDeepDive['epes'])) === 'PENDING' || getSelfStatus(getEpes(selectedDeepDive['epes'])) === 'NOT APPROVED'"
                        type="button" class="btn btn-primary" data-dismiss="modal" (click)="approve(selectedDeepDive)">
                  <i class="fa fa-check"></i> Approve
                </button>
            </div>
        </div>

    </div>
</div>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert" ></simple-alert>